import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextIndentLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M9 5H22V6.5H9V5ZM2 8.59866L7.10208 12L2 15.4014V8.59866ZM9 11.25H22V12.75H9V11.25ZM9 17.5H22V19H9V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndentLeft;
